import type { SVGProps } from 'react';

export const Search = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height="32px"
    role="img"
    viewBox="0 0 32 32"
    width="32px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{'search'}</title>
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <g>
        <rect fillRule="nonzero" height="32" width="32" x="0" y="0" />
        <g transform="translate(-0.000000, -0.000000)">
          <path
            d="M12.4444444,1.42108547e-14 C19.3173213,1.42108547e-14 24.8888889,5.57156756 24.8888889,12.4444444 C24.8888889,15.5209152 23.7725248,18.3366452 21.9227949,20.508636 L31.444954,30.0307404 C31.8354783,30.4212647 31.8354783,31.0544297 31.444954,31.444954 C31.08447,31.805438 30.517239,31.8331675 30.1249478,31.5281426 L30.0307404,31.444954 L20.508636,21.9227949 C18.3366452,23.7725248 15.5209152,24.8888889 12.4444444,24.8888889 C5.57156756,24.8888889 0,19.3173213 0,12.4444444 C0,5.57156756 5.57156756,1.42108547e-14 12.4444444,1.42108547e-14 Z M12.4444444,2 C6.67613706,2 2,6.67613706 2,12.4444444 C2,18.2127518 6.67613706,22.8888889 12.4444444,22.8888889 C18.2127518,22.8888889 22.8888889,18.2127518 22.8888889,12.4444444 C22.8888889,6.67613706 18.2127518,2 12.4444444,2 Z"
            fill={props.fill}
          />
        </g>
      </g>
    </g>
  </svg>
);
